@if (columnDataType) {
  @switch (columnDataType) {
    @case ('Text') {
      <app-text-filter [paramsGroup]="paramsGroup"></app-text-filter>
    }
    @case ('DateTime') {
      <app-date-filter [paramsGroup]="paramsGroup"></app-date-filter>
    }
    @case ('Number') {
      <app-number-filter [paramsGroup]="paramsGroup"></app-number-filter>
    }
    @case ('TextArray') {
      <app-text-array-filter [paramsGroup]="paramsGroup"></app-text-array-filter>
    }
  }
}
